import styled, { css } from "styled-components";

import { IThemeProps } from "@/styles";

import { OptionEnum, OptionModeEnum, OptionTypeEnum } from "../index";

type WrapperProps = IThemeProps<{ $clickable: boolean }>;

export const Wrapper = styled.button<WrapperProps>`
  cursor: ${(props) => (props.$clickable ? "pointer" : "default")};
  border-radius: ${(props) => props.theme.borders.textOptionRadius};
  border: ${(props) =>
    `${props.theme.borders.textOptionBorder} solid ${props.theme.colors.primary}`};
  box-shadow: ${(props) => props.theme.shadows.s100};
  overflow: hidden;
  width: 100%;
`;

type TextWrapperProps = IThemeProps<{
  $answer?: OptionEnum;
  $mode: OptionModeEnum;
  $clickable: boolean;
  $type: OptionTypeEnum;
}>;

export const TextWrapper = styled.div<TextWrapperProps>`
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  transition: all 350ms ease-in-out;

  ${(props) => props.$type === OptionTypeEnum.poll && PollText}
  ${(props) => props.$type === OptionTypeEnum.quiz && QuizText}
  ${(props) => props.$clickable && HoverTextWrapper}

  @media ${(props) => props.theme.breakpoints.mobile} {
    height: auto;
    min-height: 40px;
  }
`;

const HoverTextWrapper = css<TextWrapperProps>`
  &:hover {
    background-color: ${(props) =>
      !props.theme.globals.isTouch
        ? props.theme.colors.pollAndQuizOptionBackgroundHover
        : ""};
    color: ${(props) => props.theme.colors.pollAndQuizOptionTextHover || ""};
  }
`;

export const Text = styled.span<IThemeProps>`
  font-size: ${(props) => props.theme.typography.h200};
  font-weight: 600;
  text-align: center;
  margin: 0 10px;
  transition: color 350ms ease-in-out;
`;

const PollText = css<TextWrapperProps>`
  background-color: ${(props) =>
    props.$mode === OptionModeEnum.results && props.$answer
      ? props.theme.colors.pollAndQuizOptionBackgroundModeResult
      : props.theme.colors.pollAndQuizOptionBackground};

  color: ${(props) =>
    props.$mode === OptionModeEnum.results && props.$answer === OptionEnum.vote
      ? props.theme.colors.pollOptionTextVote
      : props.theme.colors.fontText};
`;

const QuizText = css<TextWrapperProps>`
  background-color: ${(props) =>
    props.$mode === OptionModeEnum.results && props.$answer
      ? props.theme.colors.white
      : props.theme.colors.pollAndQuizOptionBackground};

  color: ${(props) => props.theme.colors.fontText};
`;
